import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    rasa_getAll() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'rasa/get-all')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    rasa_sendText({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'rasa/send-text', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    rasa_storeLog({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'rasa/store-log', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    rasa_rasaIntentExampleDelete({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'rasa/rasa-intent-example-delete', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    rasa_rasaIntentExampleStore({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'rasa/rasa-intent-example-store', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    rasa_entrenarRasa() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'rasa/entrenar-rasa')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    rasa_getVariableEntrenandoRasa() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'rasa/get-variable-entrenando-rasa')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    rasa_intentUpdateResponse({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'rasa/intent-update-response', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    rasa_storeIntent({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'rasa/store-intent', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    rasa_getLogs() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'rasa/get-logs')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};